<template>
  <el-upload
    action="whatever"
    ref="upload"
    :multiple="multiple"
    class="ny-upload is-single"
    :class="{ 'is-multiple': multiple }"
    :file-list="fileList"
    :auto-upload="false"
    :before-upload="handleBeforeUpload"
    :on-remove="handleOnRemove"
    :on-change="handleOnChange"
    list-type="picture"
    v-bind="$attrs"
  >
    <el-button
      v-bind="$attrs"
      :disabled="btnDisabled"
      :class="{ [`is-${btnType}`]: true, 'ny-upload__btn': btnType === 'default' }"
    >{{ placeholder }}</el-button>
    <slot></slot>
    <p class="ny-upload__tip" v-if="tipText">{{tipText}}</p>
  </el-upload>
</template>


<script>
export default {
  name: 'NyUpload',
  props: {
    value: {
      required: true
    },
    multiple: Boolean,
    showFilename: Boolean,
    tipText: String,
    btnText: String,
    btnType: {
      type: String,
      default: 'default'
    },
    btnDisabled: Boolean
  },
  data () {
    return {
      fileList: this.value
    }
  },
  computed: {
    placeholder () {
      return !this.showFilename ?
        (this.btnText ? this.btnText : '选择文件') :
        this.fileList.reduce((acc, val) => acc += `${val.raw.name}, `, '').slice(0, -2)
    }
  },
  methods: {
    handleBeforeUpload (file) {
      this.$emit('before-upload', file)
    },
    handleOnChange (file, fileList) {
      this.$emit('on-change', file, fileList)
    },
    handleOnRemove (file, fileList) {
      this.$emit('on-remove', file, fileList)
    }
  },
  watch: {
    value (newVal) {
      this.fileList = newVal
    }
  }
}
</script>

<style lang="scss">
@include b(ny-upload) {
  .el-upload {
    text-align: left;
  }

  .el-upload-list {
    &__item {
      padding: 0;
      text-align: center;

      .el-upload-list__item-status-label {
        display: none;
      }
    }

    &__item-name {
      display: none;
    }

    &__item-thumbnail {
      float: none;
      width: auto;
      height: auto;
      margin: 0 auto;
    }
  }

  @include is(single) {
    .el-upload-list {
      &__item {
        height: auto;
      }

      &__item-thumbnail {
        max-width: 364px;
      }

      .el-icon-close {
        display: none;
      }
    }
  }

  @include is(multiple) {
    .el-upload-list {
      &__item {
        height: 120px;
      }

      &__item-thumbnail {
        max-height: 120px;
      }

      .el-icon-close {
        display: block;
      }
    }
  }

  @include e(btn) {
    position: relative;
    width: 364px;
    height: 28px;
    padding: 0 10px;
    line-height: 1;
    text-align: center;
    color: #0f1a23;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background: linear-gradient(0deg, #dbdbdb, #fff);
    border: 1px solid #dbdbdb;
    outline: none;
    cursor: pointer;

    &:hover,
    &:focus {
      color: #0f1a23;
      background: linear-gradient(0deg, #dbdbdb, #fff);
      border: 1px solid #dbdbdb;
    }
  }

  @include e(tip) {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #fc8675;
    text-align: left;
  }
}
</style>
